import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import LocaleContext from '../../context/LocaleProvider';
import { ProjectPageContainer } from '../PagesLayout/projects.css';
import { getQuery } from '../../functions/getQuery';
import HeadingContainer from '../PageSections/HeadingContainer/HeadingContainer';
import ProjectTiles from '../ProjectTiles/ProjectTiles';
import ProjectTilesHeader from '../ProjectTilesHeader/ProjectTilesHeader';
import { TopSpacing } from '../TopSpacing/TopSpacing.css';
import WorldMap from '../WorldMap/WorldMap';
import ProjectsContext from '../../context/ProjectsProvider';
import Transition from '../Transition/Transition';
import Footer from '../Footer/Footer';

const ProjectsLayout = ({ data }) => {
  const projectsContext = useContext(ProjectsContext);
  const lang = useContext(LocaleContext);
  const projectsJsonContent = getQuery(['projectsContent', 'data'], data);
  const allProjects = getQuery(['allProjects', 'edges'], data);
  let allProjectsJson = [...allProjects];

  // Get static total count from CMS (the "127" from homepage graphics)
  // The graphic array contains multiple items - find the one for "PROJECTS" (first item typically)
  const graphicsData = projectsJsonContent?.project_page_graphics?.document?.data?.graphic;
  // Use 127 as hardcoded fallback if CMS data not available
  const staticTotalCount = graphicsData?.[0]?.number || 127;
  
  // Check if any filters are active
  const hasActiveFilters = projectsContext.selectedCountry || projectsContext.selectedService;

  // Filter by country
  if (projectsContext.selectedCountry) {
    allProjectsJson = allProjectsJson.filter(({ node: project }) =>
      project?.data?.countries?.find(
        ({ country }) => country === projectsContext.selectedCountry
      )
    );
  }

  // Filter by service
  if (projectsContext.selectedService) {
    allProjectsJson = allProjectsJson.filter(({ node: project }) => {
      return (
        projectsContext.selectedService
          ?.toLowerCase()
          .split('  ')
          .join(' ') === project.data?.industry_selector_fr?.toLowerCase() ||
        projectsContext.selectedService
          ?.toLowerCase()
          .split('  ')
          .join(' ') === project.data?.industry_selector_eng?.toLowerCase()
      );
    });
  }

  // Filter by year - ONLY in filter mode (not timeline mode)
  // Timeline mode: project list shows ALL projects (count = 127)
  // Filter mode: project list is filtered by dropdown selections (already handled above)

  return (
    <Transition>
      <TopSpacing>
        <ProjectPageContainer>
          {projectsJsonContent.project_page_title &&
          projectsJsonContent.project_page_body ? (
            <HeadingContainer
              hideBorder
              title={projectsJsonContent.project_page_title.text}
              body={projectsJsonContent.project_page_body.text}
            />
          ) : (
            ''
          )}
          <WorldMap
            lang={lang}
            query={{
              projects: projectsJsonContent,
              services: data.allPrismicExpertise.edges[0].node,
            }}
            selectedCountry={projectsContext.selectedCountry}
            setSelectedCountry={projectsContext.setSelectedCountry}
            selectedService={projectsContext.selectedService}
            setSelectedService={projectsContext.setSelectedService}
            allProjectsJson={allProjectsJson}
            allProjects={allProjects}
            selectedYear={projectsContext.selectedYear}
            setSelectedYear={projectsContext.setSelectedYear}
            filterMode={projectsContext.filterMode}
            activateFilterMode={projectsContext.activateFilterMode}
            activateTimelineMode={projectsContext.activateTimelineMode}
          />
          <div
            id='ProjectTilesAnchor'
            style={{ transform: 'translateY(-215px)' }}
          ></div>
          <ProjectTilesHeader
            numberOfProjects={hasActiveFilters ? allProjectsJson.length : staticTotalCount}
            query={projectsJsonContent}
            selectedCountry={projectsContext.selectedCountry}
            selectedService={projectsContext.selectedService}
          />
          <ProjectTiles
            className='ProjectTiles'
            query={allProjectsJson}
            numberOfVisibleArticles={
              data.prismicArticlesSection?.data?.number_of_articles_visible
            }
            numberOfArticlesToLoad={
              data.prismicArticlesSection?.data?.number_of_articles_to_load
            }
            loadMore={
              data.prismicArticlesSection?.data?.load_more_button_label?.text
            }
          />
          <Footer />
        </ProjectPageContainer>
      </TopSpacing>
    </Transition>
  );
};

ProjectsLayout.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ProjectsLayout;
